import React from "react"
import clsx from "clsx"
import { Chip, ChipProps, Typography } from "@material-ui/core"

import SvgIcon from "@/components/SvgIcon"

import useStyles from "@/components/AIChip/styles"

import { AIIcon } from "@/assets/icons"

type AIChipProps = ChipProps & {
	size: "small" | "medium"
}

const AIChip: React.FC<AIChipProps> = (props) => {
	const { className, ...otherProps } = props

	const classes = useStyles()

	return (
		<Chip
			{...otherProps}
			classes={{
				label: classes.aiChipLabel
			}}
			className={clsx({
				[classes.aiChip]: true,
				[classes.aiChipSmallSize]: otherProps.size === "small",
				[classes.aiChipMediumSize]: otherProps.size === "medium",
				[String(className)]: Boolean(className)
			})}
			label={(
				<>
					<SvgIcon
						icon={AIIcon}
						color="primary"
						fontSize="small"
						autoSize
						className={clsx({
							[classes.aiChipIconSmallSize]: otherProps.size === "small",
							[classes.aiChipIconMediumSize]: otherProps.size === "medium"
						})}
					/>

					<Typography
						color="primary"
						variant="overline"
						className={clsx({
							[classes.aiChipTextSmallSize]: otherProps.size === "small",
							[classes.aiChipTextMediumSize]: otherProps.size === "medium"
						})}
					>
						IA
					</Typography>
				</>
			)}
		/>
	)
}

export default AIChip
